import axios from 'axios';

import { backendRequestHeaders, getBackendBaseUrl } from '@/api/backendAuth';

import {
  readPaddleDevClientTokenOverride,
  type PaddleClientBootstrap,
} from './fetchPaddleCheckoutBootstrap';

export async function fetchPaddleClientToken(sessionJwt?: string | null): Promise<PaddleClientBootstrap> {
  const o = readPaddleDevClientTokenOverride();
  if (o) return o;
  const base = getBackendBaseUrl();
  const { data } = await axios.post<PaddleClientBootstrap>(`${base}/billing/paddle/client-token`, undefined, {
    headers: backendRequestHeaders(sessionJwt),
  });
  return data;
}
